module.exports = __webpack_public_path__ + "static/aboutme-51270a72e779d21770886724d75aae72.jpg";